import SweetScroll from 'sweet-scroll';

const $body = $(document.body);

const initScroller = () => {
  console.log('initScroller');

  const main = () => {
    console.log('scroller.main fired')
    SweetScroll.create({
      horizontal: true,
    }, ".scroller");
  }

  if($body.hasClass('wp-admin')){
    //delay main execution in wp-admin
    $body.on('ag.sweetscroll.ready', main);
  } else {
    main();
  }
};

window.initScroller = initScroller;
window.SweetScroll = SweetScroll;

export default initScroller;
